import { render, staticRenderFns } from "./componentes.vue?vue&type=template&id=ef9e016c&scoped=true&"
import script from "./componentes.vue?vue&type=script&lang=js&"
export * from "./componentes.vue?vue&type=script&lang=js&"
import style0 from "./componentes.vue?vue&type=style&index=0&id=ef9e016c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef9e016c",
  null
  
)

export default component.exports